import { useEffect, useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import MemberMessageTableRow from "./member-message-table-row";
import { configs } from "../../../../app/app-configs";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import DateRangeInput from "../../../../components/form-input-field-wrappers/date-range-input";
import Grid from "@mui/material/Grid";
import { getDefaultMemberMessageSearchCriteria, MemberMessage } from "../../../../service/model/message.model";
import * as messageSlice from "../../member-message.slice";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import { parseISO, subDays } from "date-fns";

const headers: ColumnHeader[] = [
    { name: "Id" },
    { name: "Member" },
    { name: "Message" },
    { name: "Channel" },
    { name: "Count" },
    { name: "Timestamp" },
    { name: "Status" },
]

interface TableProps {
    readonly memberId?: number
    readonly messages: MemberMessage[]
}

const MemberMessageTable: React.FC<TableProps> = ({ memberId, messages }) => {
    const dispatch = useAppDispatch();
    const totalPages = useAppSelector(messageSlice.selectTotalPages);
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const [page, setPage] = useState(1);

    const [dateRange, setDateRange] = useState({
        // startDate: new Date(getDefaultMemberMessageSearchCriteria().from),
        startDate: loggedInUser?.roleData.businessUser?.business.nextBillingDate ? subDays(parseISO(loggedInUser?.roleData.businessUser.business.nextBillingDate), 30) : new Date(getDefaultMemberMessageSearchCriteria().from),
        endDate: new Date(getDefaultMemberMessageSearchCriteria().to),
    });

    useEffect(() => {
        dispatch(messageSlice.fetchMemberMessagePage({
            pagination: { page: page - 1, size: configs.PAGE_SIZE },
            memberId: memberId,
            from: dateRange.startDate.toISOString().slice(0, 10),
            to: dateRange.endDate.toISOString().slice(0, 10)
        }))
    }, [page, dateRange]);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    const handleDateChange = (start: Date | null, end: Date | null) => {
        setDateRange({ startDate: start ?? new Date(), endDate: end ?? new Date() });
    };

    return (
        <>
            <Grid container direction="row" style={{ marginTop: '12px' }}>
                <DateRangeInput
                    initialStartDate={dateRange.startDate}
                    initialEndDate={dateRange.endDate}
                    onDateChange={handleDateChange}
                />
            </Grid>
            <StyledTable headers={headers}
                currentPage={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}>

                {messages?.map(message =>
                    <MemberMessageTableRow message={message} key={message.id} />
                )}
            </StyledTable>
        </>
    );
}

export default MemberMessageTable;